import { useCallback, useEffect, useState } from 'react';
import {
  getFlujosAlmacenes,
  getFlujosCajasPalet,
  getFlujosPesosCajas,
  getFlujosPesosPalot,
  getFlujosVariedadesNav,
} from '../services/apis';
import {
  normalizeFlujosAlmacenes,
  normalizeFlujosCajasPalet,
  normalizeFlujosPesos,
  normalizeFlujosVariedadesNav,
} from '../utils/flujosCatalogsMapper';

const buildErrorMessage = (error) => {
  const message = error?.response?.data?.message || error?.message;

  if (Array.isArray(message)) {
    return message.join(', ');
  }

  return message || 'No se han podido cargar los catalogos.';
};

export const useFlujosCatalogs = () => {
  const [state, setState] = useState({
    variedades: [],
    almacenes: [],
    pesosCaja: [],
    pesosPalot: [],
    cajasPalet: [],
    loading: true,
    error: '',
  });

  const fetchCatalogs = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: '' }));

    try {
      const [
        variedadesResponse,
        almacenesResponse,
        pesosCajaResponse,
        pesosPalotResponse,
        cajasPaletResponse,
      ] = await Promise.all([
        getFlujosVariedadesNav(),
        getFlujosAlmacenes(),
        getFlujosPesosCajas(),
        getFlujosPesosPalot(),
        getFlujosCajasPalet(),
      ]);

      setState({
        variedades: normalizeFlujosVariedadesNav(variedadesResponse),
        almacenes: normalizeFlujosAlmacenes(almacenesResponse),
        pesosCaja: normalizeFlujosPesos(pesosCajaResponse),
        pesosPalot: normalizeFlujosPesos(pesosPalotResponse),
        cajasPalet: normalizeFlujosCajasPalet(cajasPaletResponse),
        loading: false,
        error: '',
      });
    } catch (error) {
      setState({
        variedades: [],
        almacenes: [],
        pesosCaja: [],
        pesosPalot: [],
        cajasPalet: [],
        loading: false,
        error: buildErrorMessage(error),
      });
    }
  }, []);

  useEffect(() => {
    fetchCatalogs();
  }, [fetchCatalogs]);

  return {
    ...state,
    refetch: fetchCatalogs,
    pesoPalotMermaDefault: state.pesosPalot.find((row) => row.peso === 183)?.peso || state.pesosPalot[0]?.peso || 183,
  };
};
